'use client';

import type { FC, HTMLAttributes, ReactElement } from 'react';
import { createElement } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';

interface TitleProps extends HTMLAttributes<HTMLHeadingElement> {
  level?: '1' | '2' | '3';
  weight?: '1' | '2' | '3';
}

const titleVariants = cva(
  'm-0 text-white leading-tight',
  {
    variants: {
      level: {
        '1': 'text-3xl',
        '2': 'text-2xl',
        '3': 'text-xl',
      },
      weight: {
        '1': 'font-medium',
        '2': 'font-semibold',
        '3': 'font-bold',
      },
    },
    defaultVariants: {
      level: '3',
      weight: '3',
    },
  },
);

export const Title: FC<TitleProps> = ({ children, level = '3', weight = '3', className, ...props }) => {
  const tag = `h${level}`;

  return createElement(
    tag,
    {
      className: cn(titleVariants({ level, weight }), className),
      ...props,
    },
    children,
  ) as ReactElement;
};
